import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const BoxWrapper = styled(NormalizedWrapper)`
  ${({ theme, marginTop = '0px' }) => css`
    margin: ${theme.spaces[3]}px auto;
    margin-top: ${marginTop};
    width: 100%;
    z-index: 1;

    ${theme.below.laptop`
      padding: ${theme.spaces[2]}px;
      margin-top: ${theme.spaces[0]}px;
    `}

    ${theme.below.tablet`
      padding: ${theme.spaces[0]}px;
      margin-top: ${theme.spaces[2]}px;
    `}
  `}
`
